import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from '../Avatar';
import templateData, { localsMessages } from '../../utility/getTemplateData';
import {
	showSpinnerOverlay
} from '../../utility/helper';
import {
	getHardLogoutUrl,
	isOneTouchUser
} from '../../utility/authUtils';
import {
	trackLinkClickWithData
} from '../../utility/fpt';
import { sanitize } from '../../utility/domUtils';

const messages = localsMessages('common/oneTouch')
const PROFILE_PHOTO_PLACEHOLDER = 'https://www.paypalobjects.com/images/shared/icon_profile_placeholder@2x.png';

class UserDetailsBanner extends Component {
	static propTypes = {
		userDetails: PropTypes.object
	}

	createLoggedInMessage = (firstName) => {
		let loggedInMessage = isOneTouchUser() ?
			messages.banner.oneTouchGreeting :
			messages.banner.fullLoginGreeting;

		return loggedInMessage.replace('{firstName}', sanitize(firstName));
	}

	handleNotYouLinkClick = () => {
		showSpinnerOverlay();
		trackLinkClickWithData('not-you', {
			authState: templateData.authState
		});
		this.logout();
	}

	logout = () => {
		window.location.href = getHardLogoutUrl();
	}

	render() {
		const { userDetails = {} } = this.props;
		const firstName = userDetails.firstName || '';
		const profilePhotoUrl = userDetails.thumbnailUrl || PROFILE_PHOTO_PLACEHOLDER;

		return (
			<div className="user-details-banner">
				<Avatar thumbnailUrl={profilePhotoUrl} />
				<div className="details-container">
					<div className="details">
						<div className="hi-msg" dangerouslySetInnerHTML={{ __html: this.createLoggedInMessage(firstName) }}></div>
						<div className="not-you-link">
							<a href="#" onClick={this.handleNotYouLinkClick}>
								{messages.banner.notYou}
							</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default UserDetailsBanner;



// WEBPACK FOOTER //
// ./components/onetouch/UserDetailsBanner.js